module.exports = __webpack_public_path__ + "static/media/empty-state-test.3cbe9f6d.svg";